export default __webpack_public_path__ + "static/estrutura-4-7aca312c14be1e4b608db4d6bc78e4b1.png";